import { isNil } from 'lodash-es';
import {
  CLEAR_NOTIFICATIONS,
  CREATE_NOTIFICATION,
  DELETE_NOTIFICATION,
  NotificationActions,
  NotificationReducerState,
  RESET_REDUCER,
} from 'services/App/Notifications/types';
import { generateRandomId } from 'utils/functions';

const INITIAL_STATE = {
  notifications: [],
};

const reducer = (previousState: NotificationReducerState | undefined, action: NotificationActions): NotificationReducerState => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    // Notifications
    case CREATE_NOTIFICATION: {
      const notificationExists = state.notifications.some(
        (notification) => notification === action.notification || (!isNil(notification?.id) && notification.id === action.notification.id),
      );

      if (notificationExists) {
        // already exist
        return state;
      }

      return {
        ...state,
        notifications: state.notifications.concat({ ...action.notification, id: action.notification.id ?? generateRandomId() }),
      };
    }

    case DELETE_NOTIFICATION: {
      return { ...state, notifications: state.notifications.filter(({ id }) => id !== action.id) };
    }

    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };
    // Reset
    case RESET_REDUCER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default reducer;
